export const LINK_TAIL_NAME = 'TAIL';
export const LINK_HEAD_NAME = 'HEAD';
